// import React, { useState, useEffect } from 'react';
// import './Navbar.css';
// import nakamu from '../images/nakamu.png';

// const Navbar = () => {
//     const [userName, setUserName] = useState('Loading...');
//     const [userOccupation, setUserOccupation] = useState('Fetching role...');

//     useEffect(() => {
//         const fetchUserProfile = async () => {
//             try {
//                 const token = localStorage.getItem('token');
//                 if (!token) {
//                     console.error('No authentication token found.');
//                     return;
//                 }

//                 const apiUrl = `${process.env.REACT_APP_SERVER_IP}/api/admin/my-profile`;
//                 const response = await fetch(apiUrl, {
//                     method: 'GET',
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 });

//                 if (!response.ok) {
//                     throw new Error('Failed to fetch user profile');
//                 }

//                 const userData = await response.json();

//                 // Assuming API returns { firstName: "Jeet", lastName: "Bhalani", category: "Fullstack Developer" }
//                 setUserName(`${userData.firstName} ${userData.lastName}`);
//                 setUserOccupation(userData.occupation || 'No Category');
//             } catch (error) {
//                 console.error('Error fetching user profile:', error);
//                 setUserName('User not found');
//                 setUserOccupation('Unknown Role');
//             }
//         };

//         fetchUserProfile();
//     }, []);

//     return (
//         <header className="header">
//             <nav>
//                 <div className="navbar-right">
//                     <img src={nakamu} alt="Profile Logo" className="profile-logo" />
//                     <div className="text-container">
//                         <h1>{userName}</h1>
//                         <h3>{userOccupation}</h3>
//                     </div>
//                 </div>
//                 <div className="middle-space"></div>
//             </nav>
//         </header>
//     );
// };

// export default Navbar;

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import model from '../images/model.png';
import nakamu from '../images/nakamu.png';
import './Navbar.css';

const Navbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [userName, setUserName] = useState('Loading...');
  const [userOccupation, setUserOccupation] = useState('Fetching role...');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isWebsite, setIsWebsite] = useState(window.innerWidth > 768);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No authentication token found.');
          return;
        }

        const apiUrl = `${process.env.REACT_APP_SERVER_IP}/api/admin/my-profile`;
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user profile');
        }

        const userData = await response.json();
        setUserName(`${userData.firstName} ${userData.lastName}`);
        setUserOccupation(userData.occupation || 'No Category');
      } catch (error) {
        console.error('Error fetching user profile:', error);
        setUserName('User not found');
        setUserOccupation('Unknown Role');
      }
    };

    fetchUserProfile();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsWebsite(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const routeTitles = {
    '/home': 'Dashboard',
    '/adduser': 'Add User',
    '/createadmin': 'View Users',
    '/OneToOneAdd': 'Add One-To-One',
    '/OneToOneReview': 'View One-To-One',
    '/AddReferral': 'Add Referral',
    '/ReferralGiven': 'View Referral',
    '/FeesAdd': 'Add Fees',
    '/FeesReview': 'View Fees',
    '/ThankyouAdd': 'Add Thank You Slip',
    '/ThankYouReview': 'View Thank You Slip',
    '/AddMeetings': 'Add Attendance Date',
    '/ViewMeetings': 'View/ Edit Attendance',
    '/editprofile': 'Edit Profile',
    '/changepass': 'Change Password',
    '/ViewProfile': 'View All Members',
  };

  return (
    <header>
      <nav>
        <div className="navbar-container">
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
            {isMobile && (
              <>
                {routeTitles[location.pathname] && <h3 className="dashboard">{routeTitles[location.pathname]}</h3>}
                <div className="sidebar-toggle">
                  <img src={model} alt="Menu" onClick={() => setIsSidebarOpen(true)} style={{ cursor: 'pointer' }} />
                </div>
              </>
            )}
          </div>

          {isWebsite && (
            <div className="navbar-right">
              <img src={nakamu} alt="Profile Logo" className="profile-logo" />
              <div className="text-container">
                <h1>{userName}</h1>
                <h3>{userOccupation}</h3>
              </div>
            </div>
          )}

          <div className="middle-space"></div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
